import { FC } from 'react';
import { useApps } from '../hooks/use-apps';
import { ReactComponent as LinkedInIcon } from '../../../../../components/icons/linkedin-bigger.svg';
import { BaseAppCard } from './base-app-card';
import { ChannelAccountStatus } from '@zaplify/channel-accounts/shared';

interface LinkedInAuthCardProps {
    account: ReturnType<typeof useApps>['accounts']['linkedin'];
}

export const LinkedInAuthCard: FC<LinkedInAuthCardProps> = ({ account }) => {
    return (
        <BaseAppCard
            title="LinkedIn"
            appId="linkedin"
            bgColor="bg-blue-50"
            icon={<LinkedInIcon className="h-6 w-6 object-contain" />}
            isConnected={account.isConnected}
            isActive={account.isActive}
            handleConnect={account.connectToLinkedIn}
            isLoading={account.state.isLoading}
            isError={account.state.connectingStatus === 'error'}
            connectButtonText={
                account.status === ChannelAccountStatus.NOT_AUTHENTICATED ? 'Reconnect LinkedIn' : 'Connect LinkedIn'
            }
            avatar={{
                avatarUrl: account.avatarUrl,
                handle: account.name,
                handleLinkUrl: account.linkedinProfileUrl,
            }}
            hideSettingsButton
        />
    );
};
